/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

const RovingTabIndexContext = createContext();
export const useRovingTabIndexContext = () =>
	useContext( RovingTabIndexContext );
export const RovingTabIndexProvider = RovingTabIndexContext.Provider;
